<template>
    <div class="ly_body">
        <div>
            <!--    <transition name="loader-animation" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">-->
            <!--      <progress-bar :show-loader="showLoader" :loader-style="loaderStyle" />-->
            <!--    </transition>-->
            <app-header/>
            <div class="js_setHeaderHeightToPaddingTop h_100p">
                <transition
                    name="page-transition"
                    mode="out-in"
                    appear
                    @before-enter="beforeEnter"
                >
                    <router-view></router-view>
                </transition>
            </div>
        </div>
        <app-loader/>
        <app-footer/>
    </div>
</template>

<script>
// ヘッダー
import Header from './components/partials/Header.vue';
// フッター
import Footer from './components/partials/Footer.vue';
// ローディング
import Loader from './components/partials/Loader';


export default {
    components: {
        appHeader: Header,
        appFooter: Footer,
        appLoader: Loader,
    },
    methods: {
        beforeEnter() {
            window.dispatchEvent(new CustomEvent('ScrollBehavior'));
        },
    },

    created() {
        /**
         *
         */
        this.$lax.init();

        /**
         * ヘッダーの高さをパディングトップに指定する。
         *
         * <header id="js_getHeaderHeight">
         *
         * <div id="js_setHeaderHeightToPaddingTop">
         *
         */
        class SetHeaderHeightToPaddingTop {
            constructor() {
                this.header     = null;
                this.targetElms = null;
                this.timer      = false;
            }

            init() {
                Promise.resolve()
                    .then(() => {
                        return new Promise(resolve => {
                            // 必要な要素を取得
                            this.header     = document.getElementById('js_getHeaderHeight');
                            this.targetElms = Array.prototype.slice.call(document.getElementsByClassName('js_setHeaderHeightToPaddingTop'));
                            return resolve();
                        });
                    })
                    .then(() => {
                        this.adjustEvent();
                        window.addEventListener('resize', () => {
                            if (this.timer != false) clearTimeout(this.timer);
                            this.timer = setTimeout(() => {
                                this.adjustEvent();
                            }, 50);
                        }, false);
                    })
            }

            adjustEvent() {
                this.targetElms.forEach(targetElm => {
                    console.log(this.header.clientHeight);
                    targetElm.style.paddingTop = this.header.clientHeight + 'px';
                });
            }
        }

        let setHeaderHeightToPaddingTop = new SetHeaderHeightToPaddingTop();
        setHeaderHeightToPaddingTop.init();

    },
    mounted() {
        /**
         * lax.js
         */
        this.$lax.addDriver('scrollY', function () {
            return window.scrollY;
        }, {});
    },
};
</script>

<style lang="scss">
.page-transition-enter,
.page-transition-leave-to {
    opacity: 0;
}

.page-transition-enter-active,
.page-transition-leave-active {
    transition: opacity 500ms;
}
</style>
